export default __webpack_public_path__ + "static/media/searchIcon2.d773ed92.svg";